document.writeln(
    `
    <!-- Quick Links -->
      <div>
        <div class="label_header label_header--margin_adjustment">
          <p>Quick links</p>
        </div>
        <ul class="quicklink__list">
          <li class="quicklink__list__item">
            <a href="#">Confirm Delivery Location</a>
          </li>
          <li class="quicklink__list__item">
            <a href="#">Disclaimer</a>
          </li>
          <li class="quicklink__list__item">
            <a href="#">FAQ's</a>
          </li>
        </ul>
      </div>
      <!-- SPLITTER -->
      <hr class="horizontalruler" />
      <!-- Contact Section -->
      <div class="contact_container">
        <div class="contact_content">
          <p>Get in touch</p>
          <div class="contact_content_body">
            <i
              class="fa fa-envelope-o facustom--item--nowidth"
              aria-hidden="false"
            ></i>
            <a href="#" id="">Email Us</a>
          </div>
        </div>
        <div class="contact_content">
          <p>Follow us</p>
          <div class="contact_content_body">
            <a
              href="https://www.instagram.com/kokoandinyene/"
              id=""
              target="_blank"
              ><i
                class="fa fa-instagram facustom--item--nowidth"
                aria-hidden="false"
              ></i
            ></a>
            <a
              href="https://www.instagram.com/kokoandinyene/"
              id=""
              target="_blank"
              ><i
                class="fa fa-facebook-square facustom--item--nowidth"
                aria-hidden="false"
              ></i
            ></a>
          </div>
        </div>
      </div>
    `
)